import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import warning from "@/assets/myaccount/warning.svg";


interface ReloginDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ReLoginDialog: React.FC<ReloginDialogProps> = ({
  open,
  onOpenChange,

}) => {
  

const handleLoginAgain = () => {          
    window.location.reload(); 
        onOpenChange(false);    
};

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
      onInteractOutside={(e) => e.preventDefault()}
  onEscapeKeyDown={(e) => e.preventDefault()}


       hideCloseButton className="w-[30%] max-w-[900px] p-0 flex flex-col rounded-xl overflow-hidden bg-white">
        <DialogHeader className="bg-[#f4f4f4] text-[#181818] text-[22px] px-6 py-4">
          <DialogTitle>Access Rights Updated</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <div className="flex flex-col items-center justify-center text-center px-6 py-4 space-y-4">
            <img src={warning} alt="Warning" className="w-20 h-20" />
            <p className="text-[#363636] text-[16px] leading-[24px]">
              Your access rights have been updated due to subscription changes.
              <br />
              Please reload to continue.
            </p>
          </div>
        </DialogDescription>

    <DialogFooter className="w-full flex !justify-center border-t border-gray-200 p-4">

      <Button
        className="px-6 h-[40px] bg-charcoal hover:bg-charcoal/70 text-white rounded-md"
        size="sm"
        onClick={handleLoginAgain}
      >
        Reload
      </Button>
    </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ReLoginDialog;
